import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';
import { prepareFilters } from '../../../components/Filters/request';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      ...item,
      key: item.id,
      select: { id: item.id, value: false },
      creator: item.assigned_user,
      title: { id: item.id, code: item.code, description: item.short_summary, purpose: item.purpose },
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getCodes({ payload: { signal, type, filters, searchQ, curr_page } }) {
  try {

    const { sort, status, created_by_split } = prepareFilters(filters);

    const { data } = yield call(fetch, {
      api: api.codes.list,
      params: {
        page: curr_page,
        ...(searchQ && { q: searchQ }),
        purpose: type,
        ...(sort && { ordering: sort[0] }),
        ...(status ? { status } : {}),
        ...(created_by_split ? { created_by_split: created_by_split === 'yes' } : {})
      },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getCodesDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getCodesFailed,
      endpoint: api.codes.list.url
    });
  }
}

export const getCodesSaga = takeEvery(types.GET_CODES_REQUEST, getCodes);